import { render, staticRenderFns } from "./bottom-sheet.vue?vue&type=template&id=4e49f874&"
import script from "./bottom-sheet.vue?vue&type=script&lang=ts&"
export * from "./bottom-sheet.vue?vue&type=script&lang=ts&"
import style0 from "./bottom-sheet.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBottomNavigation } from 'vuetify/lib/components/VBottomNavigation';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBadge,VBottomNavigation,VBtn,VIcon})
